import React from "react";
import styled from "styled-components";
import * as Router from "next/router";
import Head from "next/head";

import { A, CL, H2 } from "@/components/Typography";

const Rx404Screen = () => {
  const router = Router.useRouter();

  return (
    <S.Page>
      <Head>
        <title>Page not found | AllBright</title>
      </Head>
      <H2>404</H2>
      <CL>Whoops! We can't find the page you're looking for.</CL>
      <CL>
        <A onClick={() => router.back()}>Go back</A>, or if you were expecting
        to see something here then please{" "}
        <A onClick={() => router.push("/contact#contact-form")}>get in touch</A>
        !
      </CL>
    </S.Page>
  );
};

const S = () => {};

S.Page = styled.div`
  width: 100%;
  min-height: 600px;
  background: shell;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 10%;
  text-align: center;
`;

export default Rx404Screen;
